import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter);

export default new VueRouter({
    routes: [{
        name: "Login",
        path: "/Login",
        component: () =>
            import("../common/login/Login.vue")
    },
    {
        name: "PersonalTest",
        path: "/PersonalTest",
        component: () =>
            import("../pages/PersonalTest.vue"),
    },
    {
        name: "Main",
        path: "/Main",
        component: () =>
            import("../Main.vue"),
        children: [
            {
                name: "DataStatistics",
                path: "/DataStatistics",
                component: () =>
                    import("../pages/DataStatistics.vue"),
            },
            {
                name: "TourManagement",
                path: "/TourManagement",
                component: () =>
                    import("../pages/TourManagement.vue"),
            },
            {
                name: "ResultManagement",
                path: "/ResultManagement",
                component: () =>
                    import("../pages/ResultManagement.vue"),
            },
            {
                name: "ResultTest",
                path: "/ResultTest",
                component: () =>
                    import("../pages/ResultTest.vue"),
            },
            {
                name: "BillDetails",
                path: "/BillDetails",
                component: () =>
                    import("../pages/BillDetails.vue"),
            },
            {
                name: "PriceManagement",
                path: "/PriceManagement",
                component: () =>
                    import("../pages/PriceManagement.vue"),
            },
            {
                name: "CategoryManagement",
                path: "/CategoryManagement",
                component: () =>
                    import("../pages/CategoryManagement.vue"),
            },
            {
                name: "ProjectManagement",
                path: "/ProjectManagement",
                component: () =>
                    import("../pages/ProjectManagement.vue"),
            },
            {
                name: "duoshouDetails",
                path: "/duoshouDetails",
                component: () =>
                    import("../pages/duoshouDetails.vue"),
            },
            {
                name: "PictureSave",
                path: "/PictureSave",
                component: () =>
                    import("../pages/PictureSave.vue"),
            },
            {
                name: "DataManagement",
                path: "/DataManagement",
                component: () =>
                    import("../pages/DataManagement.vue"),
            },
            {
                name: "ExpertInformation",
                path: "/ExpertInformation",
                component: () =>
                    import("../pages/ExpertInformation.vue"),
            },
            {
                name: "EvaluationManagement",
                path: "/EvaluationManagement",
                component: () =>
                    import("../pages/EvaluationManagement.vue"),
            },
            {
                name: "ConsultingManagement",
                path: "/ConsultingManagement",
                component: () =>
                    import("../pages/ConsultingManagement.vue"),
            },
            {
                name: "ChatManagement",
                path: "/ChatManagement",
                component: () =>
                    import("../pages/ChatManagement.vue"),
            },
            {
                name: "CourseInformation",
                path: "/CourseInformation",
                component: () =>
                    import("../pages/CourseInformation.vue"),
            },
            {
                name: "AppointmentManagement",
                path: "/AppointmentManagement",
                component: () =>
                    import("../pages/AppointmentManagement.vue"),
            },
            {
                name: "BasicShare",
                path: "/BasicShare",
                component: () =>
                    import("../common/basic/BasicShare.vue"),
            },
            {
                name: "BasicNotice",
                path: "/BasicNotice",
                component: () =>
                    import("../common/basic/BasicNotice.vue"),
            },
            {
                name: "BasicParam",
                path: "/BasicParam",
                component: () =>
                    import("../common/basic/BasicParam.vue"),
            },
            {
                name: "BasicType1",
                path: "/BasicType1",
                component: () =>
                    import("../common/basic/BasicType1.vue"),
            },
            {
                name: "BasicType2",
                path: "/BasicType2",
                component: () =>
                    import("../common/basic/BasicType2.vue"),
            },
            {
                name: "LogDownLoad",
                path: "/LogDownLoad",
                component: () =>
                    import("../common/log/LogDownLoad.vue"),
            },
            {
                name: "LogException",
                path: "/LogException",
                component: () =>
                    import("../common/log/LogException.vue"),
            },
            {
                name: "LogJson",
                path: "/LogJson",
                component: () =>
                    import("../common/log/LogJson.vue"),
            },
            {
                name: "LogLogin",
                path: "/LogLogin",
                component: () =>
                    import("../common/log/LogLogin.vue"),
            },
            {
                name: "LogOperate",
                path: "/LogOperate",
                component: () =>
                    import("../common/log/LogOperate.vue"),
            },
            {
                name: "LogServer",
                path: "/LogServer",
                component: () =>
                    import("../common/log/LogServer.vue"),
            },
            {
                name: "LogApp",
                path: "/LogApp",
                component: () =>
                    import("../common/log/LogApp.vue"),
            },
            {
                name: "LogUpload",
                path: "/LogUpload",
                component: () =>
                    import("../common/log/LogUpload.vue"),
            },
            {
                name: "UserInfo",
                path: "/UserInfo",
                component: () =>
                    import("../common/user/UserInfo.vue"),
            },
            {
                name: "UserPage",
                path: "/UserPage",
                component: () =>
                    import("../common/user/UserPage.vue"),
            },
            {
                name: "UserRole",
                path: "/UserRole",
                component: () =>
                    import("../common/user/UserRole.vue"),
            }, {
                name: "UserOperate",
                path: "/UserOperate",
                component: () =>
                    import("../common/user/UserOperate.vue"),
            },
            {
                name: "UserDept",
                path: "/UserDept",
                component: () =>
                    import("../common/user/UserDept.vue"),
            },
        ]
    },
    {
        path: '/',
        redirect: '/Login'
    }
    ]
});